
export const FILTER_NO_CERTIFICATE = '-';
